import React from "react";
import { useLocation } from "react-router-dom";
import IconQuote from "assets/images/doubel-commas.svg";
import ImgVisionServices from "assets/images/img-vision.svg";
import ImgVisionAbout from "assets/images/img-vision-2.svg";

const OurVision = () => {
  const location = useLocation();
  return (
    <section className="vision-section pb-0">
      <div className="container">
        <div className="section-title">
          <h1>Our Vision</h1>
          <p>Transforming product ideas to digital reality.</p>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <fieldset>
              <legend>
                <img src={IconQuote} alt="quote icons" />
              </legend>
              <p>Empowering innovation by transforming ideas into cutting-edge digital solutions.</p>
              <p>
                {" "}
                At Transcend Solution, we bridge the gap between imagination and technology, crafting seamless digital experiences that drive success.
                With a commitment to excellence, we turn visionary concepts into reality, delivering high-quality solutions tailored to your needs.
              </p>

              <legend>Co-Founders</legend>
            </fieldset>
          </div>
          <div className="col-lg-6">
            <span className="img-wrap">
              <img src={location.pathname === "/services" ? ImgVisionServices : ImgVisionAbout} alt="not-found" />
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurVision;
